import React, { PureComponent } from 'react'
import firebase from 'firebase'
import SModal from 'components/sModal'
import SButton from 'components/sButton'
import InputMinimal from 'components/inputMinimal'
import { connect } from 'react-redux'
//import {Toast} from 'helpers/iziToast';
import './styles.css'

class EditCoinPopup extends PureComponent {
  constructor(props){
    super(props)

    this.state = {
      email: '',
      password: '',
      loading: false,
      errorMsg: ''
    }
  }

  tryToSignUp = () => {
    const { email, password } = this.state
    this.setState({ loading: true })

    firebase.auth().createUserWithEmailAndPassword(email, password)
    .then(val => {
      //Toast.success('Succesfully signed up')
      //this.props.closeModal()
    })
    .catch(error=>{
      if (error.code === 'auth/weak-password') {
        this.setState({ errorMsg: 'The password is to weak. ( min: 6 chars )' })
      } else if(error.code === 'auth/user-not-found') {
        this.setState({ errorMsg: 'There is no account with given email'})
      } else if(error.code === 'auth/invalid-email') {
        this.setState({ errorMsg: 'The email is invalid, please check again'})
      } else {
        this.setState({ errorMsg: error.code, email: ''})
      }
      this.setState({ loading: false, password: '' })
    });
  }


  render() {

    const { email, password, loading, errorMsg } = this.state
    const { closeModal } = this.props

  	return(
  		<SModal.Main onClose={closeModal} noHead={true} closeOnOutsideClick={true} title='EDIT COIN' >
  			<SModal.Body>
          <fb className="stepOneMain">
            <fb className="title">Signup to Cryptorunup</fb>
            <fb className="logoRow icon-poll"></fb>
            <fb className="infoText">
              Get premium access to real time data for all listed altcoins.
            </fb>
            { errorMsg && <fb className="errorRow">{errorMsg}</fb> }
  					<fb className='signupBox'>
  						<InputMinimal defaultText="email" 		value={email} onInputChange={val => this.setState({email: val})} icon='email' iStyle={{fontSize: 16}} rounded autoFocus email/>
  						<InputMinimal defaultText="password" 	value={password} onInputChange={val => this.setState({password: val})} icon='lock'  iStyle={{fontSize: 16}} rounded onEnter={this.tryToSignUp} password/>
  						<SButton
  							label={loading ? '...' : 'Signup' }
  							onClick={this.tryToSignUp}
  							sStyle={{alignSelf: 'stretch', margin: '8px 2px 0px 2px' }}
  							color='#219cff'
  						/>
  					</fb>
  				</fb>
  			</SModal.Body>
  		</SModal.Main>
  	)
  }
}

const mapStateToProps = (state: Store) => ({

})

export default connect(mapStateToProps) (EditCoinPopup)



// WEBPACK FOOTER //
// ./src/modals/signupModal/signupStep/index.js